import React, { useEffect, useState } from 'react';
import { Box, Grid, Paper, Alert, SpeedDial, SpeedDialIcon } from '@mui/material';
import { TrainingList, Summary } from './Index';
import dummyDataList from './TraininglistDummyData.json';
import { StencilList } from "react-placemoulder";
import TrainingFilter from './TrainingFilter';
import { styled } from '@mui/material/styles';
import { training_list } from '../../../redux/actions/training.action';
import { useDispatch, useSelector } from 'react-redux';
import { CustomizedSnackbar } from '../../../shared/index';
import InfiniteScroll from "react-infinite-scroller";
import EditIcon from "@mui/icons-material/Edit";
import CommentModal from './CommentModal';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  borderRadius: 10
}));

function UpcomingTraining() {
  const dispatch = useDispatch();
  const [trainingList, setTrainingList] = useState(dummyDataList);
  const [loading, setLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(7);
  const [title, setTitle] = useState("");
  const [level, setLevel] = useState("");
  const [emp, setEmp] = useState(0);
  const [date, setDate] = useState("");
  const [year, setYear] = useState("");
  const [empLevel, setEmpLevel] = useState("");
  const [statusId, setStatusId] = useState(0);
  const [pagination, setPagination] = useState({});
  const [scrolling, setScrolling] = useState(false);
  const [count, setCount] = useState(0);
  const [summary, setSummary] = useState({});
  const [orderby, setOrderBy] = useState("StatusId");
  const [orderByDirection, setOrderByDirect] = useState("asc");
  const [commentModal, setcommentModal] = useState(false);
  const [rejectComment, setRejectComment] = useState("");


  let trainingListReducer = useSelector(state => state.fetchTrainingList_Reducer.trainingList)

  useEffect(() => {
    var req = {
      "page": pageNo,
      "resultsPerPage": resultsPerPage,
      "title": title,
      "year": year,
      "trainingLevelId": level,
            "employeeLevelId":empLevel,
      "dateFilter": date,
      "statusId": statusId,
      "employeeId": emp,      
      "orderBy": orderby,
      "orderByDirection": orderByDirection,
    }
    fetchTrainingList(req)
  }, [])
  const fetchTrainingList = (req) => {
    dispatch(training_list(req))
  };
  const handlePagination = () => {
    if (pageNo + 1 <= pagination.totalPages) {
      setPageNo(pageNo + 1)
      var req = {
        "page": pageNo + 1,
        "resultsPerPage": resultsPerPage,
        "title": title,
        "year": year,
        "trainingLevelId": level,
            "employeeLevelId":empLevel,
        "dateFilter": date,
        "statusId": statusId,
        "employeeId": emp,
        "orderBy": orderby,
        "orderByDirection": orderByDirection,
      }
      fetchTrainingList(req)
      setScrolling(true)
    }
  }
  useEffect(() => {
    if (trainingListReducer !== undefined) {
      if (trainingListReducer.pagination !== undefined) {
        setPagination(trainingListReducer.pagination)
        setPageNo(trainingListReducer.pagination.page)
      }
      if ( trainingList && trainingList.length > 0 && trainingListReducer.pagination&&trainingListReducer.pagination.page > 1) {
        var list = [...trainingList, ...trainingListReducer.trainings];
        console.log(list)
        setTrainingList(list)
        setScrolling(false);
        if (trainingListReducer.pagination !== undefined) {
          setPagination(trainingListReducer.pagination)
          setPageNo(trainingListReducer.pagination.page)
        }
      }
      else {
        setLoading(false)
        setTrainingList(trainingListReducer.trainings)
        setSummary(trainingListReducer.summary)
        if (trainingListReducer.pagination !== undefined) {
          setPagination(trainingListReducer.pagination)
          setPageNo(trainingListReducer.pagination.page)
        }
      }

    }

  }, [trainingListReducer])

  const onSearch = (req) => {
    setLoading(true)
    dispatch(training_list(req))
  }

  const handleTitleFilter = (value) => {
    setTitle(value)
  }

  const handleLevelFilter = (id) => {
      setLevel(id)
  }

  const handleEmployeeFilter = (id) => {
      setEmp(id)
  }

  const handlePeriodFilter = (date,year) => {
      setDate(date);
      setYear(year);
  }
  const handleStatusFilter = (id) => {
    setStatusId(id)
  }
  const handleEmpLevelFilter = (id) => {
    setEmpLevel(id)
  }
  const handleSort = (order,sort) => {
    setOrderBy(order)
    setOrderByDirect(sort)
    var req = {
        "page": 1,
        "resultsPerPage": resultsPerPage,
        "title": title,
        "year": year,
        "trainingLevelId": level,
        "employeeLevelId":empLevel,
        "dateFilter": date,
        "statusId": statusId,
        "employeeId": emp,
        "orderBy": order,
        "orderByDirection": sort,
    }
    setLoading(true)
    fetchTrainingList(req)
  }
//   const handleOrderBy = (value) => {
//     setOrderBy(value)
//     var req = {
//         "page": 1,
//         "resultsPerPage": resultsPerPage,
//         "title": title,
//         "year": year,
//         "levelId": level,
//         "dateFilter": date,
//         "statusId": statusId,
//         "employeeId": emp,
//         "orderBy": value,
//         "orderByDirection": orderByDirection,
//     }
//     setLoading(true)
//     fetchTrainingList(req)
// }
  const handleComment = (val) => {
    if(commentModal){
      setcommentModal(false)
    }    
    else{
      setRejectComment(val);
      setcommentModal(true)
    }
  }
  return (
    <div>
      <h1 className="main-heading">Training List</h1>
      <Grid container spacing={2}>
      <Grid item xs={12}>
        {/* {loading ?
          <StencilList
          length={1}
          Component={Summary}
          data={trainingList}
          />: */}
          <>{summary !== undefined && summary !== null?
          <Summary count = {pagination.totalRecords} summary = {summary} handleArrow={handleSort} order={orderByDirection}/>:""
          }
          </>
        {/* // } */}
        </Grid>
        <Grid item xs={3}>
          <TrainingFilter 
            searchTitle={handleTitleFilter}
            serachLevel = {handleLevelFilter}
            searchEmployee = {handleEmployeeFilter}
            searchPeriod = {handlePeriodFilter}
            searchStatus = {handleStatusFilter}
            searchEmpLevel={handleEmpLevelFilter}
            // sortBy = {handleOrderBy}
            onFilter = {onSearch}
          />
        </Grid>   
        <Grid item xs={9}>
          <Box>
            {loading ?
              <StencilList
                length={5}
                Component={TrainingList}
                data={trainingList}
              /> :
              <>
              <InfiniteScroll
                // dataLength={trainingList.length}
                initialLoad={false}
                loadMore={scrolling === false ? handlePagination : ""}
                hasMore={pageNo <= pagination.totalPages}
                threshold={500}
                >
                  {/* {trainingList && trainingList.length > 0?(orderByDirection === "asc"?<ArrowUpwardIcon fontSize='small' onClick={()=>handleSort("desc")}/>:<ArrowDownwardIcon onClick={()=>handleSort("asc")}/>):""} */}
                {trainingList && trainingList.length > 0 && trainingList.map((trainingList) => {
                  return <TrainingList {...trainingList} key={trainingList.id} handleCommentModal={handleComment} work="view"/>
                })}

              </InfiniteScroll>
                    {trainingList && trainingList.length === 0 ?<Alert severity="error">No Trainings Found</Alert>:""}
                    </>
            }
          </Box>
        </Grid>
      </Grid>
      <CustomizedSnackbar />
      
      <CommentModal open={commentModal} handleCommentModal={handleComment} comment={rejectComment}/>

    </div>
  )
}
export default UpcomingTraining;